export const SystemSetting = {
  path: '/system/settings',
  component: () => import('@/View/SystemSetting/Layout/Layout.vue'),
  hidden: true,
  redirect: {name: 'SystemSettingC'},
  name: 'SystemSetting',
  meta: {
    breadCrumb: 'SystemSetting',
    icon: 'dashboard',
    title: 'SystemSetting',
    selected: false,
    permissionList: ['abc', 'def']
  },
  children: [
    { // SystemSetting dashboard start
      path: 'dashboard',
      component: () => import('@/View/SystemSetting/Dashboard/dashboard.vue'),
      hidden: false,
      icon: 'dashboard',
      name: 'SystemSettingC',
      meta: {
        icon: 'dashboard',
        breadCrumb: 'SystemSetting',
        title: 'Dashboard',
        selected: false,
        permissionList: ['abc', 'def']
      }
    },
    { // SystemSetting Company start
      path: 'company',
      component: () => import('@/View/SystemSetting/Company/company.vue'),
      hidden: false,
      icon: 'fas fa-building',
      name: 'Company',
      selected: true,
      meta: {
        icon: 'fas fa-building',
        color: 'primary',
        breadCrumb: 'Company',
        title: 'Company',
        selected: true,
        permissionList: ['abc', 'def']
      }
    },
    { // SystemSetting Time Zone start
      path: 'timezone',
      component: () => import('@/View/SystemSetting/TimeZone/TimeZone.vue'),
      hidden: false,
      icon: 'mdi-clock',
      name: 'TimeZone',
      selected: true,
      meta: {
        icon: 'mdi-clock',
        color: 'primary',
        breadCrumb: 'TimeZone',
        title: 'Time Zone',
        selected: true,
        permissionList: ['abc', 'def']
      }
    },
    { // SystemSetting Invoice start
      path: 'invoice',
      component: () => import('@/View/SystemSetting/Invoice/Invoice.vue'),
      hidden: false,
      icon: 'fas fa-file-invoice',
      name: 'InvoiceSetting',
      selected: true,
      meta: {
        icon: 'fas fa-file-invoice',
        color: 'primary',
        breadCrumb: 'Invoice Details',
        title: 'Invoice',
        selected: true,
        permissionList: ['abc', 'def']
      }
    },
    { // SystemSetting Invoice start
      path: 'employment',
      component: () => import('@/View/SystemSetting/Employment/Employment.vue'),
      hidden: false,
      icon: 'fas fa-briefcase',
      name: 'Employment',
      selected: true,
      meta: {
        icon: 'fas fa-briefcase',
        color: 'primary',
        breadCrumb: 'Employment',
        title: 'Employment',
        selected: true,
        permissionList: ['abc', 'def']
      }
    },
    { // SystemSetting Order start
      path: 'order',
      component: () => import('@/View/SystemSetting/Order/Order.vue'),
      hidden: false,
      icon: 'fas fa-receipt',
      name: 'OrderSettings',
      selected: true,
      meta: {
        icon: 'fas fa-receipt',
        color: 'primary',
        breadCrumb: 'Order',
        title: 'Order',
        selected: true,
        permissionList: ['abc', 'def']
      }
    },
    { // SystemSetting WorkOrder start
      path: 'workorder',
      component: () => import('@/View/SystemSetting/WorkOrder/WorkOrder.vue'),
      hidden: false,
      icon: 'fas fa-code-branch',
      name: 'WorkOrderSetting',
      selected: true,
      meta: {
        icon: 'fas fa-code-branch',
        color: 'primary',
        breadCrumb: 'WorkOrder',
        title: 'Work Order',
        selected: true,
        permissionList: ['abc', 'def']
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/View/SystemSetting/Router/index.js